import { render } from "./HasOneField.vue?vue&type=template&id=33049093"
import script from "./HasOneField.vue?vue&type=script&lang=js"
export * from "./HasOneField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sites/avaliacao/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HasOneField.vue"]])

export default __exports__